module.exports = __webpack_public_path__ + "assets/img/about-us.9c7aa1a7.png";